/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface OptOutRequestRef
 */
export interface OptOutRequestRefOptional {
  /**
   *
   * @type {number}
   * @memberof OptOutRequestRef
   */
  reqId?: number;
}

export interface OptOutRequestRef extends OptOutRequestRefOptional {
  /**
   *
   * @type {number}
   * @memberof OptOutRequestRef
   */
  reqId: number;
}

export interface OptOutRequestRefTrackedI {
  /**
   *
   * @type {number}
   * @memberof OptOutRequestRef
   */
  reqId?: number;
  reqIdIsSet: boolean;
}

transformDatesMap.set(
  "OptOutRequestRef",
  function (model: OptOutRequestRef) {},
);

export type OptOutRequestRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  reqId: PropertyMeta<MetaTypeBase<number>>;
}>;

export var OptOutRequestRefMeta: OptOutRequestRefMetaI =
  {} as OptOutRequestRefMetaI;
OptOutRequestRefMeta = typeMeta("OptOutRequestRef", {
  reqId: propertyMeta("reqId", false, true, true, MetaTypesBase.number),
});

const metaI = OptOutRequestRefMeta;

registerMeta(() => {});

export class OptOutRequestRefTracked implements OptOutRequestRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  reqId__I?: number = undefined;

  get reqIdIsSet() {
    return this.reqId !== undefined;
  }
  set reqIdIsSet(v: boolean) {}
  set reqId(v: undefined | number) {
    if (v !== undefined) {
      this.reqId__I = v;
      this.reqIdIsSet = true;
    } else {
      this.reqId__I = v || undefined;
      this.reqIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get reqId() {
    return this.reqId__I;
  }
  constructor(config?: OptOutRequestRefOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.reqIdIsSet == true && other?.reqIdIsSet == true)
      return this.reqId == other.reqId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.reqId) {
      this.reqIdIsSet = true;
    }
  }
  assignFrom(
    config: OptOutRequestRefOptional,
    options?: AssignOptions,
  ): OptOutRequestRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.reqId && this.reqIdApplyFilter(optionsRequired.filter)) {
      this.reqId = config.reqId;
      if (optionsRequired.unassign) this.reqIdIsSet = false;
      else this.reqIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OptOutRequestRefTrackedI {
    const cloned = {} as OptOutRequestRefTrackedI;
    if (
      this.reqIdIsSetDeep() &&
      this.reqIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reqIdIsSet = true;
      cloned.reqId = this.reqId;
    } else {
      //cloned.reqIdIsSet = false
    }
    if (!isDeleted(this) && !this.reqIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OptOutRequestRefTrackedI {
    if (!this.reqIdApplyFilter(filter)) this.reqIdIsSet = false;

    return this;
  }
  reqIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutRequestRefMeta.reqId,
      OptOutRequestRefMeta,
      this.reqId,
      this,
    );
  }
  reqIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reqIdIsSet && this.reqIdApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.reqIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
